import React from 'react';
import CityLayout from '../../components/CityLayout';
import '../../styles/index.scss';

const Copenhagen = () => <CityLayout city="København" />;

export default Copenhagen;
